export default __webpack_public_path__ + "static/media/Seismic.c79dad8f.svg";